import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminPanel.css";
import { baseurl } from "./CoocpeatHome";

function AdminPanel() {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        getAllOrders();
    }, []);

    const updateStatus = async (orderId) => {
        try {
            const token = localStorage.getItem("admin_token");

            await axios.put(
                baseurl + "admin/updateOrderStatus",
                { id: orderId, status: "Delivered" },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            // update UI instantly
            setOrders(prev =>
                prev.map(order =>
                    order.id === orderId ? { ...order, status: "Delivered" } : order
                )
            );
        } catch (error) {
            console.error("Failed to update status:", error);
            alert("Unable to update status");
        }
    };

    const getAllOrders = async () => {
        try {
            const token = localStorage.getItem("admin_token");

            const response = await axios.get(baseurl + "admin/getAllOrders", {
                headers: { Authorization: `Bearer ${token}` },
            });

            setOrders(response.data.orders);
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    return (
        <div className="admin-orders-container">
            <h1 className="page-title">All Orders</h1>

            {/* Static Header */}
            <div className="static-header">
                <span>Order ID</span>
                <span>Name</span>
                <span>Mobile</span>
                <span>Product</span>
                <span>Qty</span>
                <span>Amount</span>
                <span>Order Date</span>
                <span>Expected Delivery</span>
                <span>Status</span>
            </div>

            {/* Scrollable List */}
            <div className={`flatlist ${orders.length > 10 ? "scroll-enabled" : ""}`}>
                {orders.map((item) => (
                    <div className="order-item" key={item.id}>

                        <span>{item.OrderNo}</span>
                        <span>{item.customerDetails?.customerName}</span>
                        <span>{item.customerDetails?.customerMobile}</span>
                        <span>
                            {item.productName?.length > 21
                                ? item.productName.substring(0, 21) + "…"
                                : item.productName}
                        </span>

                        <span>{item.quantity}</span>
                        <span>₹{item.TotalPaidAmount}</span>

                        <span>
                            {new Date(item.createdAt).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true
                            })}
                        </span>

                        <span>
                            {item.deliveryDate
                                ? new Date(item.deliveryDate).toLocaleDateString("en-IN")
                                : "—"}
                        </span>

                        {/* Status Button */}
                        <button
                            className={`status-btn ${item.status?.toLowerCase()}`}
                            disabled={item.status === "Delivered"}
                            onClick={
                                item.status === "Delivered"
                                    ? null
                                    : () => updateStatus(item.id)
                            }
                        >
                            {item.status === "Delivered" ? "Delivered" : "Mark Delivered"}
                        </button>

                    </div>
                ))}
            </div>
        </div>
    );
}

export default AdminPanel;
